import {useEffect, useRef} from "react";

import {UserEditPage} from "@pages/admin/UserPage/UserEditPage";
import {UserViewPage} from "@pages/admin/UserPage/UserViewPage";
import {ProfilePage} from "@pages/common/ProfilePage";
import {BorderArticle} from "@ui/general/BorderArticle";
import {useSelector} from "react-redux";
import {useLocation} from "react-router-dom";

import {Certifications} from "./Certifications";
import {Feedback} from "./Feedback";
import {Statistic} from "./Statistic";
import styles from "./styles.module.scss";

export const ProfileLayout = () => {
  const PATHS = {
    VIEW: "/view/",
    EDIT: "/edit/",
    PROFILE: "/profile",
  };

  const location = useLocation();

  const {isMobile} = useSelector((state) => state.common.settings);
  const {role} = useSelector((state) => state.common.candidate);
  const {current} = useSelector((state) => state.user.view);
  const profileRef = useRef(null);

  useEffect(() => {
    if (profileRef.current && isMobile) {
      profileRef.current.scrollIntoView({behavior: "smooth"});
    }
  }, [location]);

  const renderLayout = () => {
    if (location.pathname.includes(PATHS.VIEW)) {
      return <UserViewPage />;
    }

    if (location.pathname.includes(PATHS.EDIT)) {
      return <UserEditPage />;
    }

    return <ProfilePage />;
  };

  const shouldShowFeedback = () => {
    // 1. На странице /edit - не показываем
    if (location.pathname.includes(PATHS.EDIT)) {
      return false;
    }

    // 2. На странице /view - показываем если текущий пользователь "Admin" и роль просматриваемого пользователя не "Admin"
    if (location.pathname.includes(PATHS.VIEW)) {
      return role !== "Representative" && current?.role !== "Admin";
    }

    // 3. На странице /profile - показываем если текущий пользователь не "Admin"
    if (location.pathname.includes(PATHS.PROFILE)) {
      return role !== "Admin";
    }

    return false;
  };

  return (
    <div className={"container-small"}>
      <div
        ref={profileRef}
        className={styles.profileWrapper}
      >
        <BorderArticle>{renderLayout()}</BorderArticle>

        {shouldShowFeedback() && (
          <>
            <BorderArticle>
              <Feedback />
            </BorderArticle>

            <BorderArticle>
              <Certifications />
            </BorderArticle>

            <BorderArticle>
              <Statistic />
            </BorderArticle>
          </>
        )}
      </div>
    </div>
  );
};
